import { projectsCreateProjectFromSunpay } from '@sunwisesoftware/client-aftersales-js';

import { showFastApiErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import * as afterSalesMonitoringActions from '../../afterSalesMonitoring/actions';
import {
    SAVE_DATA,
    SAVE_DATA_FAILURE,
    SAVE_DATA_SUCCESS,
} from '../actionTypes';
import { SOURCE_FIELD_KEYS } from '../constants';
import { actions } from '../reducer';

export default ({ successCallback, sunwiseProjectId, values }) =>
    (dispatch) => {
        if (!values?.credential?.id || !sunwiseProjectId) return;
        dispatch(actions[SAVE_DATA]());

        const newValues = {
            company_sk_id: values.credential.id,
            name:
                values.power_station?.station_name || values.power_station?.id,
            read_requirements: {
                station_id: values.power_station?.id,
                station_name: values.power_station?.station_name,
            },
            sunwise_project: sunwiseProjectId,
        };
        const fields = Object.values(SOURCE_FIELD_KEYS);

        for (const field of fields) {
            newValues[field] = values[field] || false;
        }

        projectsCreateProjectFromSunpay({
            path: { company_id: values.credential.id },
            body: newValues,
        })
            .then(() => {
                dispatch(actions[SAVE_DATA_SUCCESS]());
                showToast();

                dispatch(
                    afterSalesMonitoringActions.connectSocket(sunwiseProjectId),
                );

                if (successCallback) successCallback();
            })
            .catch((error) => {
                dispatch(
                    actions[SAVE_DATA_FAILURE](error?.response?.data?.detail),
                );
                showFastApiErrorsAsAlert(dispatch, error?.response);
            });
    };
